import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button, Modal, Table } from 'react-bootstrap'

@observer(['globals', 'payments'])
export default class PaymentDetailsModal extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.props.payments.loadPaymentDetails(this.props.paymentId)
    }

    closePaymentDetailModal() {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    render() {

        return (
            <Modal show={this.props.open} onHide={this.closePaymentDetailModal.bind(this)}>
                <Modal.Header closeButton>
                    <Modal.Title>Payment Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table striped bordered condensed hover>
                        <tbody>
                            <tr>
                                <td>Card Number: </td>
                                <td>**** **** **** {this.props.payments.paymentDetails.cardNumber}</td>
                            </tr>
                            <tr>
                                <td>Card Type: </td>
                                <td>{this.props.payments.paymentDetails.cardType}</td>
                            </tr>
                            <tr>
                                <td>QB Invoice Number:</td>
                                <td>{this.props.payments.paymentDetails.qbOrderNumber}</td>
                            </tr>
                            <tr>
                                <td>QB Payment Number:</td>
                                <td>{this.props.payments.paymentDetails.qbPaymentNumber}</td>
                            </tr>
                            <tr>
                                <td>Payment Amount:</td>
                                <td>${parseFloat(this.props.payments.paymentDetails.amount).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Approval Code:</td>
                                <td>{this.props.payments.paymentDetails.approvalCode}</td>
                            </tr>
                            <tr>
                                <td>Date:</td>
                                <td>{this.props.payments.paymentDetails.createdAt}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="danger" onClick={ this.closePaymentDetailModal.bind(this) }><i className="fa fa-ban" aria-hidden="true"></i> Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/invoices/paymentdetailsmodal.js